import { getAirlineName, getAirlineTimeZone } from './helpers'

// Airport timezones and airline names are static data — cache them at
// module level so repeat lookups (same route re-searched, pickUp + dropOff
// legs of one booking, typo-retype) cost zero round-trips. The cache stores
// the *promise*, so two concurrent callers asking for the same key share a
// single in-flight request. Rejected promises are evicted so a transient
// failure can be retried.
const TTL_MS = 30 * 60 * 1000
const cache = new Map()

const cachedCall = (key, fn) => {
  const hit = cache.get(key)
  if (hit && hit.expiresAt > Date.now()) return hit.promise
  const promise = fn().catch(error => {
    cache.delete(key)
    throw error
  })
  cache.set(key, { promise, expiresAt: Date.now() + TTL_MS })
  return promise
}

export const getAirlineTimeZoneCached = (arrIata, depIata) =>
  cachedCall(`timezone:${arrIata}:${depIata}`, () =>
    getAirlineTimeZone(arrIata, depIata)
  )

// Repointed to the existing static airline/flight/:code backend route
// (never a third-party call — see helpers.js's getAirlineName) instead of
// airlabs /airlines. FlightNerve has no airline-code-to-name endpoint.
export const getAirlineNameCached = fname =>
  cachedCall(`airline:${fname}`, async () => {
    const airlineName = await getAirlineName(fname)
    return airlineName.Description
  })

export const clearFlightLookupCache = () => cache.clear()
